export default "__VITE_ASSET__50920d92__"